module.exports = __webpack_public_path__ + "img/customize.ce8da693.svg";